/* eslint-disable jsx-a11y/alt-text */
import React from 'react'

import Image, { ImageProps } from 'next/image'

import myImageLoader from 'imageLoader'

export type Props = ImageProps
export const NextImageWrap = (props: Props) => {
  return <Image objectFit="cover" loader={myImageLoader} {...props} />
}
